<template>
  <section
    class="mem-pillars"
    data-ui="mem-pillars"
  >
    <CdrText
      class="mem-pillars__heading"
      tag="h2"
    >
      {{ heading }}
    </CdrText>
    <ul class="mem-pillars__pillars">
      <li
        v-for="pillar in pillars"
        :key="pillar?.key"
        class="mem-pillars__pillar pillar"
      >
        <div class="pillar__image-container">
          <CdrImg
            class="pillar__image"
            :alt="pillar?.image?.alt"
            :src="pillar?.image?.src"
          />
        </div>
        <CdrText
          tag="h3"
          class="pillar__heading"
        >
          {{ pillar?.heading }}
        </CdrText>
        <CdrText
          tag="p"
          class="pillar__body"
        >
          {{ pillar?.body }}
        </CdrText>
        <CdrButton
          class="pillar__cta"
          :data-analytics-id="`${pillar.cta}_modal open`"
          modifier="link"
          @click="() => handleClick(pillar?.modalModel)"
        >
          {{ pillar?.cta }}
        </CdrButton>
      </li>
    </ul>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { CdrButton, CdrImg, CdrText } from '@rei/cedar';
import data from './model';

const emit = defineEmits(['modal-open']);

const heading = computed(() => data?.heading);
const pillars = computed(() => data?.pillars);

const handleClick = (model) => emit('modal-open', model);
</script>

<style lang="scss">
.mem-pillars {
  @include cdr-container;
  margin-top: $cdr-space-one-and-a-half-x;
  margin-bottom: $cdr-space-three-x;
  @include cdr-md-mq-up {
    margin-bottom: $cdr-space-four-x;
  }
}
.mem-pillars__heading {
  @include cdr-text-heading-serif-600;
  margin-bottom: $cdr-space-one-x;
  text-wrap: wrap;
  @include cdr-md-mq-up {
    @include cdr-text-heading-serif-800;
    margin-bottom: $cdr-space-two-x;
  }
}
.mem-pillars__pillars {
  list-style-type: none;
  padding: 0;
  margin: 0;
  @include cdr-md-mq-up {
    display: grid;
    grid-auto-flow: column;
    gap: $cdr-space-one-and-a-half-x;
  }
}
.pillar {
  padding: $cdr-space-one-x;
  background-color: $cdr-color-background-secondary;
  border-radius: $cdr-radius-softer;
  margin-bottom: $cdr-space-one-and-a-half-x;
  @include cdr-md-mq-up {
    padding: $cdr-space-two-x;
    margin-bottom: 0;
    border-radius: $cdr-radius-softest;
  }
}
.pillar__image-container {
  margin-bottom: $cdr-space-one-x;
  @include cdr-md-mq-up {
    height: 244px;
  }
}
.pillar__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left;
  aspect-ratio: 1.27;
}
.pillar__heading {
  @include cdr-text-heading-serif-600;
}
.pillar__body {
  @include cdr-text-body-300;
  margin-bottom: $cdr-space-half-x;
}
.pillar__cta {
  margin: 0;
  padding: 0;
  font-weight: $cdr-text-body-300-weight;
}
</style>
